import "babel-polyfill";
import "./libs/slick";
import "./libs/infiniteslidev2"
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {animationOnScroll} from "./modules/animationOnScroll";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {postsSlider} from "./modules/postsSlider";
import {logosSlider} from "./modules/logosSlider";
import {announcementBanner} from "./modules/announcementBanner";
import {customSelect} from "./modules/customSelect";
import {video} from "./modules/video";
import {imagesSlider} from "./modules/imagesSlider";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {heroSlider} from "./modules/heroSlider";
import {anchorLinks} from "./modules/anchorLinks";
import {popups} from "./modules/popups";
import {postFilters} from "./modules/postFilters";
import {parallax} from "./modules/parallax";
import {hash} from "./modules/hash";


binder({
    bounds: {
        "html": [constants, fullHeightPage,hash],
        ".announcement-banner": announcementBanner,
        ".header": [stickyHeader, mobileNav],
        ".has-animation": animationOnScroll,
        ".posts-slider": postsSlider,
        ".testimonials-slider": testimonialsSlider,
        ".logos-slider": logosSlider,
        "select": customSelect,
        ".video-holder": video,
        ".images-slider": imagesSlider,
        ".copy-link": copyLinkToBuffer,
        ".hero-slider": heroSlider,
        ".anchors-nav": anchorLinks,
        ".popup-link": popups,
        ".blog-section": postFilters,
        ".has-parallax": parallax
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js